// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_BEASTMEN = [{
  id: 'beastmen_forest',
  factionId: FACTIONS.BEASTMEN,
  name: 'Лесной сатир',
  priceNumens: 14000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.DARK_GREEN,
  ]
}, {
  id: 'beastmen_slave',
  factionId: FACTIONS.BEASTMEN,
  name: 'Бич народов',
  priceNumens: 55000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED
  ]
}, {
  id: 'beastmen_destruction',
  factionId: FACTIONS.BEASTMEN,
  name: 'Разрушитель святилищ',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE
  ]
}, {
  id: 'beastmen_gold_legacy',
  factionId: FACTIONS.BEASTMEN,
  name: 'Степной мясник',
  priceNumens: 120000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'beastmen_ruby_legacy',
  factionId: FACTIONS.BEASTMEN,
  name: 'Владыка бойни',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
